import { render, staticRenderFns } from "./pago-contribuciones-parcialidades.vue?vue&type=template&id=a0ee2252&lang=html&"
import script from "./pago-contribuciones-parcialidades.vue?vue&type=script&lang=js&"
export * from "./pago-contribuciones-parcialidades.vue?vue&type=script&lang=js&"
import style0 from "./pago-contribuciones-parcialidades.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports